export default __webpack_public_path__ + "static/media/related-post-05.a22e1ff4.jpg";